var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDeletePrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 3.58341L14.2333 11.9376C14.1017 14.0717 14.0358 15.1392 13.5 15.9067C13.2355 16.2861 12.8949 16.6062 12.5 16.8467C11.7025 17.3334 10.6333 17.3334 8.495 17.3334C6.35333 17.3334 5.2825 17.3334 4.48333 16.8459C4.08824 16.6049 3.74768 16.2842 3.48333 15.9042C2.94833 15.1359 2.88333 14.0667 2.755 11.9292L2.25 3.58341M1 3.58341H16M11.88 3.58341L11.3108 2.41008C10.9333 1.63008 10.7442 1.24091 10.4183 0.997581C10.346 0.943678 10.2693 0.895742 10.1892 0.854248C9.82833 0.666748 9.395 0.666748 8.52917 0.666748C7.64083 0.666748 7.19667 0.666748 6.82917 0.861748C6.74793 0.905257 6.67044 0.955429 6.5975 1.01175C6.26833 1.26425 6.08417 1.66841 5.71583 2.47591L5.21083 3.58341M6.41667 12.7501V7.75008M10.5833 12.7501V7.75008",
    stroke: "white",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeletePrice);
export default __webpack_public_path__ + "static/media/icon-delete-price.891487164f2e41f108da37f4321d18fa.svg";
export { ForwardRef as ReactComponent };